import {Component, Input, OnInit, ElementRef, NgZone, OnDestroy} from '@angular/core';
import {Storyboard} from 'storyboard-renderer';
import {
  StoryboardRenderer,
  PlayerControl,
  WaveData,
} from 'storyboard-renderer';
import {TimelineService} from 'app/storyboard/storyboard-edit/timeline/timeline.service';
import {StoryboardRendererAudioService} from './storyboard-renderer-audio.service';

@Component({
  selector: 'preview-render',
  templateUrl: './preview-render-component.component.html',
  styleUrls: ['./preview-render-component.component.scss']
})
export class PreviewRenderComponentComponent implements OnInit, OnDestroy {

  @Input() storyboard: Storyboard;

  storyboardRenderer: StoryboardRenderer;

  constructor(
    private element: ElementRef,
    private timelineService: TimelineService,
    private zone: NgZone,
    private audioService: StoryboardRendererAudioService) {
    this.element = element;
  }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      let storyboardRenderer = new StoryboardRenderer(
        this.element.nativeElement.parentElement.offsetWidth,
        this.element.nativeElement.parentElement.offsetHeight,
        this.audioService,
        this.timelineService
      );

      this.element.nativeElement.append(storyboardRenderer.app.view);

      this.storyboardRenderer = storyboardRenderer;

      if (this.storyboard){

        if (!this.timelineService.getStoryboard()){
          this.timelineService.setStoryboard(this.storyboard);
        }

        let playerControl = this.timelineService.getPlayerControl();
        if (this.storyboard.attached_audio) {
          playerControl.setAudioService(this.audioService);
          this.audioService.setAudioMedia(this.storyboard.attached_audio.media);
        }

        this.storyboardRenderer.setTimeline(this.storyboard.timeline);
        this.storyboardRenderer.setPlayerControl(playerControl);

        this.timelineService.waveData.subscribe((waveData: WaveData = null) => {
          storyboardRenderer.setWaveData(waveData);
        })

        this.timelineService.storyboardChangeEvent.subscribe(() => {
          this.timelineService.addCurrentVersionToHistory();

          this.timelineService.reloadStoryboardAttachedAudioWaveData()
            .catch((err) => {
              console.log("reloadStoryboardAttachedAudioWaveData error",err);
            });
        })
      }

      this.storyboardRenderer.startLoading();
    });

  }

  ngOnDestroy() {
    if (this.storyboardRenderer && this.storyboardRenderer.app && this.storyboardRenderer.app.destroy) {
      this.storyboardRenderer.app.destroy();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/preview/preview-render-component/preview-render-component.component.ts